"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    id: "uuid-f00cf16b-81d6-44ce-9747-512a34ea5d6d",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 404.43 385.92",
    width: "100%",
    height: "100%",
    children: [(0, jsx_runtime_1.jsx)("line", {
      x1: "184.34",
      y1: "204.26",
      x2: "228.26",
      y2: "165.06",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("line", {
      x1: "7",
      y1: "29.6",
      x2: "7",
      y2: "378.92",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "310.27 282.67 7 282.67 7 224.8 160.03 224.8 160.03 249.46 201.93 249.46 202.6 224.8 260.03 224.8 310.27 282.67",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("rect", {
      x: "272.18",
      y: "31.01",
      width: "107.8",
      height: "93.55",
      transform: "translate(30.99 236.84) rotate(-41.74)",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("rect", {
      x: "246.39",
      y: "101.09",
      width: "45.2",
      height: "55.25",
      transform: "translate(555.4 45.66) rotate(138.26)",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("rect", {
      x: "224.2",
      y: "135.59",
      width: "31.99",
      height: "37.65",
      transform: "translate(-41.83 199.12) rotate(-41.74)",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "14px"
    })]
  });
};

exports.default = Icon;